// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3EWa2","footer":"ModalError_footer__EFSat"};